module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_3.69f1ee9a.jpg";